import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DeleteCarAction,
  getAllCarAction,
} from "../../../redux/actions/CarAction";
import { Button, Modal } from "react-bootstrap";
import notify from "../../../Notifcation";
import Productpage from "../../productpage/productpage";
import { baseUrlImg } from "../../../Api/baseUrl";

const Allcar = ({
  setcategoryname,
  categoryname,
  setyear,
  namee,
  setchassenumber,
  chassenumber,
  setcartype,
  cartype,
  model,
  setmodel,
  loading,
  setLoading,
  setIsEdit,
  IsEdit,
  carid,
  setcarid,
  key,
  setKey,
  setdescrip,
  descrip,
  setprice,
  setImages,
  images,
  price,
  userData,
  setisPress,
  isPress,
  setCarImageId,
  CarImageId,
  setVideoy,
  Videoy,
  Motor,
  setMotor,
  setcolor,
  color,
  setCarNumber,
  CarNumber,
}) => {
  const dispatch = useDispatch();
  const [Deletesow, setDeletesow] = useState(false);
  const handleCloseDelete = () => setDeletesow(false);
  const handleShowDelete = (item) => {
    setDeletesow(true);
    setcarid(item.id);
  };
  // useEffect(() => {
  //   dispatch(getAllCarAction());
  // }, []);
  // const AllCar = useSelector((state) => state.CarReduser.GetallCar);
  function imageUrlArrayToBase64Array(urls, callback) {
    const base64Array = [];
    let count = 0;

    function fetchAndConvert(url) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.onloadend = function () {
            base64Array.push(reader.result);
            count++;

            // Check if all URLs have been processed
            if (count === urls.length) {
              // Callback with the array of Base64-encoded strings
              callback(base64Array);
            }
          };
          reader.readAsDataURL(blob);
        })
        .catch((error) => console.error("Error fetching image:", error));
    }

    // Iterate through the array of URLs and fetch/convert each one
    urls.forEach((url) => fetchAndConvert(url));
  }

  const update = (item) => {
    setIsEdit(true);
    setyear(item.year_car);
    setcartype(item.car_type);
    setcategoryname(item.category);
    setVideoy(item.video);
    setcolor(item.color);
    setMotor(item.motor_number);
    setCarNumber(item.car_number);
    setcarid(item.id);
    imageUrlArrayToBase64Array(
      item.car_images.map((img) => baseUrlImg + img.image_url),
      (base64Array) => {
        setImages(base64Array);
      }
    );
    setCarImageId(item.car_images.map((img) => img.id));
    setmodel(item.model);
    setchassenumber(item.chassis_number);
    setprice(item.price);
    setdescrip(item.description);
    setKey("enter");
  };
  const handleDelete = async () => {
    setisPress(true);
    await dispatch(
      DeleteCarAction({
        car_id: carid,
      })
    );
    setDeletesow(false);
    setLoading(false);
    setisPress(false);
    setcarid("");
  };
  const res = useSelector((state) => state.CarReduser.DeleteCar);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (res.data) {
            notify(res.data.message, "success");
            dispatch(getAllCarAction());
          }
        } else if (res.status !== 200 || res.status !== 201) {
          if (res.data) {
            notify(res.data.message, "error");
            dispatch(getAllCarAction());
          } else {
            notify("هناك مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <div>
      <Productpage
        update={update}
        handleShowDelete={handleShowDelete}
        userData={userData}
      />
      {/* {AllCar && AllCar.length >= 0
        ? AllCar.map((item) => (
            <>
              <p>{item.name}</p>
              <p>{item.model}</p>
              <p>{item.chassis_number}</p>
              <p>{item.category}</p>
              <p>{item.car_type}</p>
              <h1 onClick={()=>update(item)}>update</h1>
              <h1 onClick={()=>handleShowDelete(item)}>Delete</h1>
              <hr />
            </>
          ))
        : null} */}
      <Modal
        show={Deletesow}
        onHide={handleCloseDelete}
        backdrop="static"
        centered
        keyboard={false}
        contentClassName="cont"
        style={{ width: "100%", margin: "0px auto", textAlign: "center" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>هل تريد حذف العنصر</Modal.Title>
        </Modal.Header>
        {/* <Modal.Body>
          {" "}
          <Addcategory />{" "}
        </Modal.Body> */}

        <Modal.Footer>
          <Button
            variant="secondary"
            className="close"
            onClick={handleCloseDelete}
          >
            إغلاق
          </Button>
          <Button variant="secondary" className="close" onClick={handleDelete}>
            موافق
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <ToastContainer /> */}
    </div>
  );
};

export default Allcar;
